import { isResultError, MasterDataTypesEnum } from '../types';
export class MasterDataService {
    masterDataAdapter;
    constructor({ masterDataAdapter }) {
        this.masterDataAdapter = masterDataAdapter;
    }
    /**
     * List 'types-contribution-information' master datas
     * @returns list of types-contribution-information
     */
    async listTypesContributionInformation() {
        const result = await this.masterDataAdapter.listMasterDatasOfType(MasterDataTypesEnum.TYPES_CONTRIBUTION_INFORMATION);
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * List 'motifs-contribution-information' master datas
     * @returns list of motifs-contribution-information
     */
    async listMotifsContributionInformationFromType(typeId) {
        const result = await this.masterDataAdapter.listMasterDatasOfType(MasterDataTypesEnum.MOTIFS_CONTRIBUTION_INFORMATION, { odataFilter: `actif eq true and typeInformation/href eq '${typeId}'` });
        if (isResultError(result)) {
            throw result.error;
        }
        return result.response;
    }
}
//# sourceMappingURL=master-data-service.js.map